import { ListOfPermissions } from "./Permissions.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum PermissionsActionsTypes {
  CREATE_REQUEST = "permissions/CREATE_REQUEST",
  CREATE_FAIL = "permissions/CREATE_FAIL",
  CREATE_SUCCESS = "permissions/CREATE_SUCCESS",
  DISMISS_MESSAGE = "permissions/DISMISS_MESSAGE",
  EDIT_REQUEST = "permissions/EDIT_REQUEST",
  EDIT_FAIL = "permissions/EDIT_FAIL",
  EDIT_SUCCESS = "permissions/EDIT_SUCCESS",
  LIST_REQUEST = "permissions/LIST_REQUEST",
  LIST_FAIL = "permissions/LIST_FAIL",
  LIST_SUCCESS = "permissions/LIST_SUCCESS"
}

export interface PermissionsState {
  isLoadingList: boolean;
  list?: ListOfPermissions;
  message?: IMessageBar;
}

interface CreateRequest {
  type: PermissionsActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: PermissionsActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: PermissionsActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: PermissionsActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: PermissionsActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: PermissionsActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: PermissionsActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: PermissionsActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: PermissionsActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: PermissionsActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfPermissions;
  };
}

export type PermissionsReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
